import { CheckOutlined, CloseOutlined, DownloadOutlined, PrinterOutlined, SendOutlined, UndoOutlined, PaperClipOutlined } from '@ant-design/icons';
import { TongHopChamCong } from '@app/models/chamcong/ChamCong';
import { layTaiLieuChamCong, layThongKeChamCong, layTongHopChamCong, pheDuyetTongHopChamCong, thuHoiTongHopChamCong, trinhTongHopChamCong, vanPhongTraLaiChamCongTongHop, xuatBaoCaoChamCong, xuatBaoCaoChamCongTongHop } from "@app/services/chamcong";
import { Button, Col, DatePicker, DatePickerProps, Form, Input, Radio, Row, Space, Table, Tabs, Tag, Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { idQuyDauTu, maChucVu, trangThaiChamCongTongHop, urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon, validateMessages } from '../../helpers/common';
import ContainerDonViPhuTrach from '../../modules/department/ContainerDonViPhuTrach';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import DonViChamCongSelectBox from '../utils/DonViChamCongSelectBox';
import InChamCongNgoaiGio from './InChamCongNgoaiGio';
import InChamCongThang from './InChamCongThang';
const { TextArea } = Input;

const columnsDefault: ColumnsType<any> = [
    {
        title: "Họ tên",
        key: "hoTen",
        dataIndex: "hoTen",
        fixed: 'left',
        width: "300px"
    },
    {
        title: "Chức vụ",
        key: "chucVu",
        dataIndex: "chucVu",
        fixed: 'left',
        width: "150px"
    },
    {
        title: "Ngày công",
        key: "tongSoCong",
        dataIndex: "tongSoCong",
        fixed: 'left',
        align: "center",
        width: "150px"
    },
];


const ThongKeChamCong = () => {
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [danhsach, setDanhSach] = useState<any>([]);
    const [dsTaiLieu, setDsTaiLieu] = useState<any>([]);
    const [loaiCong, setLoaiCong] = useState<any>([]);
    const [searchData, setSearchData] = useState<any>({
        idDonVi: idQuyDauTu,
        tuKhoa: "",
        thangNam: new Date()
    });
    const [trinhPhoCVP, setTrinhPhoCVP] = useState(false);

    const [openModalTraLai, setOpenModalTraLai] = useState(false);
    const [openModalTrinh, setOpenModalTrinh] = useState(false);
    const menu: any = menuHelper.checkMultiPermission([Links.KPI.TongHopKPI, Links.KPI.LanhDaoDonViDuyet]);
    const [tableColumns, setTableColumns] = useState<ColumnsType<any>>(columnsDefault);
    const [tableChiTietColumns, setTableChiTietColumns] = useState<ColumnsType<any>>([]);
    const monthFormat = 'MM/YYYY';
    const [tongHopChamCong, setTongHopChamCong] = useState<TongHopChamCong | null>(null);
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [formTraLai] = Form.useForm();
    const [confirmModal, setConfirmModal] = useState<any>({});
    const layThongTinTongHopChamCong = async (thangNam: string) => {
        dispatch(showLoadingScreen());
        setTrinhPhoCVP(false);
        var rs = await layTongHopChamCong(thangNam);
        if (rs != null) {
            setTrinhPhoCVP(rs.trinhPhoCVP);
        }
        setTongHopChamCong(rs);
        dispatch(hideLoadingScreen());
    }
    const user = useSelector((state: any) => state.auth.currentUser);

    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const onFinish = async (values: any) => {
        try {
            dispatch(showLoadingScreen());
            setLoading(true);
            await vanPhongTraLaiChamCongTongHop(values);
            toast.success(`Trả lại chấm công thành công!`);
            formTraLai.setFieldValue("idChamCong", "");
            formTraLai.setFieldValue("lyDo", "");
            setReloadPage(true);
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, vui lòng thử lại!');
        }
        setOpenModalTraLai(false);
        dispatch(hideLoadingScreen());
        setLoading(false);
    };

    const onChangeDatePicker = (date: any) => {
        if (date != null) {
            searchData.thangNam = date?.startOf('month').$d;
            layThongTinTongHopChamCong(dateCommon.formatDate(date?.startOf('month').$d, 'MM/yyyy'));
        } else {
            searchData.thangNam = new Date();
            layThongTinTongHopChamCong(dateCommon.formatDate(new Date(), 'MM/yyyy'));
        }
        setSearchData({ ...searchData });
        timKiem();
    }

    const timKiem = async () => {
        setIsLoadingTable(true);
        try {
            var data = await layThongKeChamCong(searchData);
            setDanhSach(data);
            if (data && data.length > 0) {
                const sl = data[0].chiTiet?.length || 0;
                if (sl != loaiCong) {
                    const lc = data[0].chiTiet.map((x: any) => {
                        return {
                            id: x.idLoaiCong,
                            ma: x.ma,
                            ten: x.ten
                        };
                    });
                    setLoaiCong(lc);
                }
            }
            var rs = await layTaiLieuChamCong(searchData);
            setDsTaiLieu(rs || []);
        } catch (e) {
            toast.error("Lấy thông tin chấm công không thành công");
        }

        setIsLoadingTable(false);
    }

    const xuatBaoCao = async () => {
        dispatch(showLoadingScreen());
        try {
            var response = await xuatBaoCaoChamCong(searchData);
            let link = document.createElement('a');
            link.download = `BaoCaoChamCong.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
        }
        dispatch(hideLoadingScreen());
    }

    const xuatBaoCaoTongHop = async () => {
        dispatch(showLoadingScreen());
        try {
            var response = await xuatBaoCaoChamCongTongHop(searchData);
            let link = document.createElement('a');
            link.download = `BaoCaoChamCongTongHop.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
        }
        dispatch(hideLoadingScreen());
    }

    const renderColumnsTable = async () => {
        const columns: ColumnsType = [...columnsDefault];

        const groupCongThang: ColumnsType = [];
        for (var i = 0; i < loaiCong.length; i++) {
            const idx = i;
            const lc = loaiCong[i];
            if (lc.ma != "W") {
                groupCongThang.push({
                    title: <label className="mb-0" title={lc.ten}>{lc.ma || ""}</label>,
                    key: "loaicong" + i + "",
                    align: "center",
                    width: "60px",
                    render: (value, record: any, index) => {
                        var soluong = 0;
                        if (record.chiTiet == null && record.chiTiet.length >= idx) {
                            soluong = 0;
                        } else {
                            const loaiCong = record.chiTiet[idx];
                            soluong = loaiCong.soLuong || 0;
                            /*if (lc.ma != "BHXH") {
                                soluong = loaiCong.soLuong || 0;
                            }
                            else {
                                let thaiSan = record.chiTiet.find((x: any) => x.ma == "TS");
                                if (thaiSan != null) {
                                    soluong = thaiSan.soLuong
                                } else {
                                    soluong = 0
                                }
                            }*/
                        }
                        return soluong == 0 ? "-" : soluong
                    }
                })
            }
        }
        columns.push({
            title: "Chấm công tháng",
            key: "chamcongthang",
            children: groupCongThang
        });

        const groupTangCa: ColumnsType = [];
        groupTangCa.push({
            title: <label className="mb-0" title="Ngày thường">NT</label>,
            key: "tangcangaythuong",
            align: "center",
            width: "50px",
            render: (value, record: any, index) => {
                if (!record.ngoaiGio) {
                    return "";
                }

                return record.ngoaiGio.ngoaiGioNgayThuong
            }
        });

        groupTangCa.push({
            title: <label className="mb-0" title="Cuối tuần">CT</label>,
            key: "tangcacuoituan",
            align: "center",
            width: "50px",
            render: (value, record: any, index) => {
                if (!record.ngoaiGio) {
                    return "";
                }

                return record.ngoaiGio.ngoaiGioCuoiTuan
            }
        });

        groupTangCa.push({
            title: <label className="mb-0" title="Ngày lễ">NL</label>,
            key: "tangcangayle",
            align: "center",
            width: "50px",
            render: (value, record: any, index) => {
                if (!record.ngoaiGio) {
                    return "";
                }

                return record.ngoaiGio.ngoaiGioNgayLe
            }
        });

        columns.push({
            title: "Tăng ca",
            key: "tangca",
            align: "center",
            children: groupTangCa
        });

        setTableColumns(columns);
    }

    const renderChiTietColumnsTable = () => {
        const columns: ColumnsType<any> = [
            {
                title: "Họ tên",
                key: "hoTen",
                dataIndex: "hoTen",
                fixed: 'left',
                width: 200,
            },
            {
                title: "Chức vụ",
                key: "chucVu",
                dataIndex: "chucVu",
                fixed: 'left',
                width: 150,
            },
        ];

        const thuMap = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
        const thangNamDayjs = dayjs(searchData.thangNam);
        const daysInMonth = thangNamDayjs.isValid() ? thangNamDayjs.daysInMonth() : 30;

        for (let i = 0; i < daysInMonth; i++) {
            const dayNum = i + 1;
            const dateObj = thangNamDayjs.date(dayNum);
            const thu = thuMap[dateObj.day()];

            columns.push({
                title: (
                    <span>
                        {dayNum}<br />{thu}
                    </span>
                ),
                key: `ngayCong_${dayNum}`,
                align: 'center',
                width: 70,
                render: (value, record: any) => {
                    let ngaycong: any = null;
                    if (record?.ctcc && Array.isArray(record.ctcc)) {
                        if (record.ctcc[i] && (dayjs(record.ctcc[i].ngay).date() === dayNum || new Date(record.ctcc[i].ngay).getDate() === dayNum)) {
                            ngaycong = record.ctcc[i];
                        } else {
                            ngaycong = record.ctcc.find((c: any) => {
                                if (!c?.ngay) return false;
                                return dayjs(c.ngay).date() === dayNum || new Date(c.ngay).getDate() === dayNum;
                            });
                        }
                    }

                    if (!ngaycong) {
                        return <span></span>;
                    }

                    const tieuDe = ngaycong?.ghiChu
                        ? `${ngaycong?.tenLoaiCong || ngaycong?.maLoaiCong || ''} - ${ngaycong.ghiChu}`
                        : (ngaycong?.tenLoaiCong || ngaycong?.maLoaiCong || '');

                    return (
                        <Tooltip title={tieuDe || undefined}>
                            <div>
                                {ngaycong?.maLoaiCong === "W" ? (
                                    <span>&nbsp;</span>
                                ) : (
                                    <span>{ngaycong?.maLoaiCong || ''}</span>
                                )}
                                {ngaycong?.ghiChu && (
                                    <div className="hrm-ghichu-chamcong">{ngaycong.ghiChu}</div>
                                )}
                            </div>
                        </Tooltip>
                    );
                }
            });
        }

        const thongKe: ColumnsType<any> = [];
        thongKe.push({
            title: "HL",
            key: "tongSoCong",
            width: 60,
            align: "center",
            render: (value, record: any) => {
                return <Tooltip title="Ngày công hưởng lương"><span>{record.tongSoCong || 0}</span></Tooltip>;
            }
        });

        for (let i = 0; i < loaiCong.length; i++) {
            const idx = i;
            const lc = loaiCong[i];
            if (lc.ma !== "W") {
                thongKe.push({
                    title: lc.ma,
                    key: "loaicong_" + i,
                    width: 60,
                    align: "center",
                    render: (value, record: any) => {
                        let soluong = 0;
                        if (record.chiTiet) {
                            const item = record.chiTiet.find((x: any) => x.idLoaiCong === lc.id || x.ma === lc.ma) || record.chiTiet[idx];
                            soluong = item?.soLuong || 0;
                        }
                        return <Tooltip title={lc.ten}><span>{soluong === 0 ? "-" : soluong}</span></Tooltip>;
                    }
                });
            }
        }

        columns.push({
            title: "Thống kê",
            key: "thongke",
            align: "center",
            children: thongKe
        });

        const groupTangCa: ColumnsType<any> = [];
        groupTangCa.push({
            title: <label className="mb-0" title="Ngày thường">NT</label>,
            key: "tangcangaythuong",
            align: "center",
            width: 50,
            render: (value, record: any) => {
                if (!record.ngoaiGio) return "";
                return record.ngoaiGio.ngoaiGioNgayThuong || "";
            }
        });
        groupTangCa.push({
            title: <label className="mb-0" title="Cuối tuần">CT</label>,
            key: "tangcacuoituan",
            align: "center",
            width: 50,
            render: (value, record: any) => {
                if (!record.ngoaiGio) return "";
                return record.ngoaiGio.ngoaiGioCuoiTuan || "";
            }
        });
        groupTangCa.push({
            title: <label className="mb-0" title="Ngày lễ">NL</label>,
            key: "tangcangayle",
            align: "center",
            width: 50,
            render: (value, record: any) => {
                if (!record.ngoaiGio) return "";
                return record.ngoaiGio.ngoaiGioNgayLe || "";
            }
        });

        columns.push({
            title: "Tăng ca",
            key: "tangca",
            align: "center",
            children: groupTangCa
        });

        setTableChiTietColumns(columns);
    }

    const onChangeDepartment = (e: any) => {
        if (e) {
            searchData.idDonVi = e.id;
        } else {
            searchData.idDonVi = 1;
        }
        setSearchData({ ...searchData });
        timKiem();
    };

    const eventTrinhTongHopChamCong = async () => {
        try {
            dispatch(showLoadingScreen);
            var rs = await trinhTongHopChamCong(dateCommon.formatDate(searchData.thangNam, 'MM/yyyy'), trinhPhoCVP);
            setTongHopChamCong(rs);
            toast.success("Trình tổng hợp chấm công thành công.");
            dispatch(hideLoadingScreen);
        } catch (error: any) {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        }
    }
    const eventThuHoiTongHopChamCong = async () => {
        dispatch(showLoadingScreen());

        try {
            var rs = await thuHoiTongHopChamCong(tongHopChamCong?.id || 0);
            toast.success("Thu hồi tổng hợp chấm công thành công");
            setTongHopChamCong(rs);
        } catch (e: any) {
            toast.error("Thu hồi tổng hợp chấm công không thành công");
        }

        dispatch(hideLoadingScreen());
    }
    const eventPheDuyetTongHopChamCong = async (pheDuyet: boolean) => {
        dispatch(showLoadingScreen());
        try {
            var rs = await pheDuyetTongHopChamCong({
                id: tongHopChamCong?.id || 0,
                isDuyet: pheDuyet
            });
            if (pheDuyet) {
                toast.success(user.maChucVu == maChucVu.giamDoc ? "Phê duyệt tổng hợp Chấm công thành công" : "Trình tổng hợp Chấm công thành công");
            } else {
                toast.success("Trả lại tổng hợp Chấm công thành công");
            }
            setTongHopChamCong(rs);
        } catch (e: any) {
            toast.error("Trình/ Trả lại tổng hợp Chấm công không thành công");
        }
        dispatch(hideLoadingScreen());
    }
    const containerDepartmentProps = {
        showHeader: false,
        isKPI: false,
        donViQuanLy: true,
        onChange: onChangeDepartment,
        value: searchData.idDonVi
    }

    const componentRefCCT = React.createRef<any>();

    const printCCT = useReactToPrint({
        content: () => componentRefCCT.current,
    });
    const componentRefCCTG = React.createRef<any>();

    const printCCTG = useReactToPrint({
        content: () => componentRefCCTG.current,
    });

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        let thangNamParams = (params.get('thangNam') || '');
        var thangNamDate = dateCommon.convertThangNamToDate(thangNamParams);

        if (thangNamDate != null) {
            searchData.thangNam = thangNamDate;
            setSearchData({ ...searchData });
        }
        if (reloadPage) {
            layThongTinTongHopChamCong(thangNamDate != null ? thangNamParams : dateCommon.formatDate(searchData.thangNam, 'MM/yyyy'));
            timKiem();

            setReloadPage(false);
        }
    }, [reloadPage])

    useEffect(() => {
        renderColumnsTable();
        renderChiTietColumnsTable();
    }, [loaiCong, searchData.thangNam])

    const getTrangThaiChamCongTongHop = (trangThai: number) => {
        var tag = (<Tag color="default"></Tag>);
        switch (trangThai) {
            case trangThaiChamCongTongHop.khoiTao: tag = (<Tag color="processing">Khởi tạo</Tag>); break;
            case trangThaiChamCongTongHop.thuHoi: tag = (<Tag color="warning">Thu hồi</Tag>); break;
            case trangThaiChamCongTongHop.trinhPhoCVP: tag = (<Tag color="purple">Trình phó chánh văn phòng</Tag>); break;
            case trangThaiChamCongTongHop.phoCVPTraLai: tag = (<Tag color="error">Phó chánh văn phòng từ chối</Tag>); break;
            case trangThaiChamCongTongHop.trinhCVP: tag = (<Tag color="cyan">Trình chánh văn phòng</Tag>); break;
            case trangThaiChamCongTongHop.chanhVPTraLai: tag = (<Tag color="error">Chánh văn phòng từ chối</Tag>); break;
            case trangThaiChamCongTongHop.trinhGiamDoc: tag = (<Tag color="gold">Trình lãnh đạo đơn vị</Tag>); break;
            case trangThaiChamCongTongHop.giamDocTraLai: tag = (<Tag color="error">Lãnh đạo đơn vị từ chối</Tag>); break;
            case trangThaiChamCongTongHop.pheDuyet: tag = (<Tag color="success">Duyệt</Tag>); break;
        }
        return tag;
    }
    return (
        <>
            <ModalTextForm
                show={confirmModal.isShowModal}
                title={confirmModal.title}
                handleClose={() => setConfirmModal({ isShowModal: false })}
                handleSave={() => {
                    confirmModal.onSubmit();
                    setConfirmModal({ isShowModal: false });
                }}
            >
                {confirmModal.content}
            </ModalTextForm>
            <section>
                <ContentHeader title="Thống kê chấm công" />
                <Row className="form-group" gutter={16}>
                    <Col span={6}>
                        <DatePicker
                            changeOnBlur={true}
                            value={dayjs(searchData.thangNam)}
                            style={{ width: "100%" }}
                            placeholder="Tháng đánh giá"
                            picker="month"
                            format={thangNamFormat}
                            onChange={onChangeDatePicker}
                        />
                    </Col>
                    <Col span="8">
                        <ContainerDonViPhuTrach {...containerDepartmentProps} />
                    </Col>
                    {/*
                <Col span={8}>
                    <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên, mã nhân viên, email, số điện thoại" value={searchData.tuKhoa}
                        onChange={(e) => {
                            searchData.tuKhoa = e.target.value;
                            setSearchData({ ...searchData });
                        }} />
                </Col>*/}
                    <Col span={10}>
                        <Space className="float-right">{/*
                        <Button
                            type="primary"
                            icon={<SearchOutlined rev="" />}
                            onClick={timKiem}
                        >
                            Tìm kiếm
                        </Button>*/}
                            <Button
                                onClick={xuatBaoCao}
                                className="hrm-btn hrm-btn-success"
                                icon={<DownloadOutlined rev="" />}>
                                Xuất excel
                            </Button>
                            <Button
                                onClick={xuatBaoCaoTongHop}
                                className="hrm-btn hrm-btn-success"
                                icon={<DownloadOutlined rev="" />}>
                                Xuất tổng hợp
                            </Button>
                            <Button
                                className="hrm-btn-print"
                                icon={<PrinterOutlined rev="" />}
                                onClick={() => {
                                    printCCT();
                                }}
                            >
                                In CCT
                            </Button>
                            <Button
                                className="hrm-btn-print"
                                icon={<PrinterOutlined rev="" />}
                                onClick={() => {
                                    printCCTG();
                                }}
                            >
                                In CCTG
                            </Button>
                        </Space>
                    </Col>
                </Row>
                <div className="card card-primary" style={{ padding: '12px 16px', marginBottom: '10px' }}>
                    <Row className="form-group" gutter={8}>
                        {
                            tongHopChamCong != null ?
                                <Col span={8}>
                                    <label>Trạng thái: {getTrangThaiChamCongTongHop(tongHopChamCong?.trangThai)}</label>
                                </Col>
                                : (danhsach || []).length > 0 ? <Col span={8}>
                                    <label>Trạng thái: {getTrangThaiChamCongTongHop(0)}</label>
                                </Col> : null
                        }
                        {
                            // button của giám đốc
                            tongHopChamCong != null && tongHopChamCong.trangThai == trangThaiChamCongTongHop.trinhGiamDoc && menu[Links.KPI.LanhDaoDonViDuyet] && user.maChucVu == maChucVu.giamDoc &&
                            <Col span={16}>
                                <Space className="float-right">
                                    <Button
                                        className="hrm-btn-delete float-right"
                                        icon={<CloseOutlined rev="" />}
                                        onClick={() => {
                                            setConfirmModal({
                                                isShowModal: true,
                                                title: "Trả lại tổng hợp Chấm công",
                                                content:
                                                    <>Bạn có muốn <label>Trả lại</label> bảng tổng hợp chấm công này không?</>,
                                                onSubmit: () => { eventPheDuyetTongHopChamCong(false) }
                                            });
                                        }} >
                                        Trả lại
                                    </Button>
                                    <Button
                                        type="primary"
                                        className="hrm-btn float-right"
                                        icon={<CheckOutlined rev="" />}
                                        onClick={() => {
                                            setConfirmModal({
                                                isShowModal: true,
                                                title: "Duyệt tổng hợp chấm công",
                                                content: <>Bạn có muốn <label>duyệt</label> bảng tổng hợp chấm công này không?</>,
                                                onSubmit: () => { eventPheDuyetTongHopChamCong(true) }
                                            });
                                        }}
                                    >
                                        Duyệt
                                    </Button>
                                </Space>
                            </Col>
                        }
                        {//buton của chuyên viên
                            menu[Links.KPI.TongHopKPI] && (danhsach || []).length > 0 && !(user.maChucVu == maChucVu.phoCVP || user.maChucVu == maChucVu.chanhVP) ?
                                (tongHopChamCong == null || (tongHopChamCong != null && tongHopChamCong.trangThai == trangThaiChamCongTongHop.chanhVPTraLai && !tongHopChamCong.trinhPhoCVP)
                                    || (tongHopChamCong != null && (tongHopChamCong.trangThai == trangThaiChamCongTongHop.phoCVPTraLai || tongHopChamCong.trangThai == trangThaiChamCongTongHop.thuHoi)))
                                    ? <Col span={16}>
                                        <Space className="float-right">
                                            <Button
                                                className="hrm-btn-delete  float-right"
                                                icon={<CloseOutlined rev="" />}
                                                size='small'
                                                onClick={() => {
                                                    setOpenModalTraLai(true);
                                                    formTraLai.setFieldValue("idChamCong", undefined);
                                                    formTraLai.setFieldValue("lyDo", "");
                                                }}
                                            >
                                                Trả lại
                                            </Button>
                                            <Button
                                                className="hrm-btn hrm-btn-warning float-right"
                                                icon={<SendOutlined rev="" />}
                                                size='small'
                                                onClick={() => {
                                                    setOpenModalTrinh(true);
                                                }}
                                            >
                                                Văn phòng tổng hợp
                                            </Button>
                                        </Space>
                                    </Col> : ((tongHopChamCong != null && tongHopChamCong.trangThai == trangThaiChamCongTongHop.trinhPhoCVP)
                                        ? <Col span={16}>
                                            <Button
                                                className="hrm-btn hrm-btn-warning float-right"
                                                icon={<UndoOutlined rev="" />}
                                                size='small'
                                                onClick={() => {
                                                    setConfirmModal({
                                                        isShowModal: true,
                                                        title: "Thu hồi tổng hợp chấm công",
                                                        content: <>Bạn có muốn <label>Thu hồi</label> bảng tổng hợp chấm công này không?</>,
                                                        onSubmit: eventThuHoiTongHopChamCong
                                                    });
                                                }}
                                            >
                                                Thu hồi
                                            </Button>
                                        </Col> : null) :
                                null
                        }
                        {//buton của phó CVP
                            menu[Links.KPI.TongHopKPI] && (danhsach || []).length > 0 && user.maChucVu == maChucVu.phoCVP ?
                                (tongHopChamCong == null) || (tongHopChamCong != null && tongHopChamCong.trangThai == trangThaiChamCongTongHop.thuHoi && user.idNhanVien == tongHopChamCong.idNguoiTrinh)
                                    ? <Col span={16}>
                                        <Space className="float-right">
                                            <Button
                                                className="hrm-btn-delete  float-right"
                                                icon={<CloseOutlined rev="" />}
                                                size='small'
                                                onClick={() => {
                                                    setOpenModalTraLai(true);
                                                    formTraLai.setFieldValue("idChamCong", undefined);
                                                    formTraLai.setFieldValue("lyDo", "");
                                                }}
                                            >
                                                Trả lại
                                            </Button>
                                            <Button
                                                className="hrm-btn hrm-btn-warning float-right"
                                                icon={<SendOutlined rev="" />}
                                                size='small'
                                                onClick={() => {
                                                    setOpenModalTrinh(true);
                                                }}
                                            >
                                                Văn phòng tổng hợp
                                            </Button>
                                        </Space>
                                    </Col> : ((tongHopChamCong != null && tongHopChamCong.trangThai == trangThaiChamCongTongHop.trinhCVP && user.idNhanVien == tongHopChamCong.idNguoiTrinh && !tongHopChamCong.trinhPhoCVP)
                                        ? <Col span={16}>
                                            <Button
                                                className="hrm-btn hrm-btn-warning float-right"
                                                icon={<UndoOutlined rev="" />}
                                                size='small'
                                                onClick={() => {
                                                    setConfirmModal({
                                                        isShowModal: true,
                                                        title: "Thu hồi tổng hợp chấm công",
                                                        content: <>Bạn có muốn <label>Thu hồi</label> bảng tổng hợp chấm công này không?</>,
                                                        onSubmit: eventThuHoiTongHopChamCong
                                                    });
                                                }}
                                            >
                                                Thu hồi
                                            </Button>
                                        </Col> : null) :
                                null
                        }
                        {
                            //button của Phó CVP
                            tongHopChamCong != null && (tongHopChamCong.trangThai == trangThaiChamCongTongHop.trinhPhoCVP || tongHopChamCong.trangThai == trangThaiChamCongTongHop.chanhVPTraLai) && menu[Links.KPI.TongHopKPI] && user.maChucVu == maChucVu.phoCVP
                            && tongHopChamCong.trinhPhoCVP
                            && <Col span={16} className="float-right">
                                <Space className="float-right">
                                    <Button
                                        className="hrm-btn-delete float-right"
                                        icon={<CloseOutlined rev="" />}
                                        onClick={() => {
                                            setConfirmModal({
                                                isShowModal: true,
                                                title: "Trả lại tổng hợp Chấm công",
                                                content:
                                                    <>Bạn có muốn <label>Trả lại</label> bảng tổng hợp chấm công này không?</>,
                                                onSubmit: () => { eventPheDuyetTongHopChamCong(false) }
                                            });
                                        }} >
                                        Trả lại
                                    </Button>
                                    <Button onClick={() => {
                                        setConfirmModal({
                                            isShowModal: true,
                                            title: "Trình tổng hợp Chấm công",
                                            content:
                                                <>Bạn có muốn <label>Trình</label> bảng tổng hợp chấm công này không?</>,
                                            onSubmit: () => { eventPheDuyetTongHopChamCong(true) }
                                        });
                                    }}
                                        type="primary" className="float-right" icon=<SendOutlined rev="" />>
                                        Trình
                                    </Button>
                                </Space>
                            </Col>
                        }
                        {
                            //button của CVP
                            tongHopChamCong != null && (tongHopChamCong.trangThai == trangThaiChamCongTongHop.trinhCVP || tongHopChamCong.trangThai == trangThaiChamCongTongHop.giamDocTraLai) && menu[Links.KPI.TongHopKPI] && user.maChucVu == maChucVu.chanhVP
                            && <Col span={16} className="float-right">
                                <Space className="float-right">
                                    <Button
                                        className="hrm-btn-delete float-right"
                                        icon={<CloseOutlined rev="" />}
                                        onClick={() => {
                                            setConfirmModal({
                                                isShowModal: true,
                                                title: "Trả lại tổng hợp Chấm công",
                                                content:
                                                    <>Bạn có muốn <label>Trả lại</label> bảng tổng hợp chấm công này không?</>,
                                                onSubmit: () => { eventPheDuyetTongHopChamCong(false) }
                                            });
                                        }} >
                                        Trả lại
                                    </Button>
                                    <Button onClick={() => {
                                        setConfirmModal({
                                            isShowModal: true,
                                            title: "Trình tổng hợp Chấm công",
                                            content:
                                                <>Bạn có muốn <label>Trình</label> bảng tổng hợp chấm công này không?</>,
                                            onSubmit: () => { eventPheDuyetTongHopChamCong(true) }
                                        });
                                    }}
                                        type="primary" className="float-right" icon=<SendOutlined rev="" />>
                                        Trình
                                    </Button>
                                </Space>
                            </Col>
                        }
                    </Row>
                    <Row gutter={16}>
                        <Col span={24} style={{ marginBottom: "10px" }}>
                            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                                <PaperClipOutlined style={{ color: '#64748b', fontSize: '18px' }} />
                                <label style={{ fontWeight: 600, color: '#334155', fontSize: '14px', margin: 0, marginRight: '4px' }}>
                                    File đính kèm:
                                </label>

                                {dsTaiLieu.map((value: any, index: number) => (
                                    <div
                                        key={index}
                                        onClick={() => window.open(urlAdmin + value?.duongDan?.replace(/\\/g, "/"), '_blank')}
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            padding: '4px 10px',
                                            backgroundColor: '#e0f2fe',
                                            border: '1px solid #bae6fd',
                                            color: '#0369a1',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '13px',
                                            transition: 'all 0.2s',
                                            fontWeight: 500,
                                            maxWidth: '300px'
                                        }}
                                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#bae6fd'}
                                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0f2fe'}
                                    >
                                        <span
                                            style={{
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                display: 'block',
                                                width: '100%'
                                            }}
                                            title={value.tenTep}
                                        >
                                            {value.tenDonVi}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </div>
                <Row gutter={16}>
                    <Col span="24">
                        <div className="card card-primary" style={{ padding: '0 16px 16px 16px' }}>
                            <Tabs
                                defaultActiveKey="tongHop"
                                items={[
                                    {
                                        key: "tongHop",
                                        label: "Bảng tổng hợp",
                                        children: (
                                            <Table
                                                scroll={{ x: 'calc(700px + 50%)' }}
                                                bordered
                                                loading={isLoadingTable}
                                                locale={{ emptyText: "Không có dữ liệu" }}
                                                dataSource={(danhsach || []).map((item: any, index: number) => {
                                                    return { ...item, key: index };
                                                })}
                                                columns={tableColumns}
                                            />
                                        )
                                    },
                                    {
                                        key: "chiTiet",
                                        label: "Bảng chi tiết",
                                        children: (
                                            <Table
                                                scroll={{ x: 'max-content' }}
                                                bordered
                                                loading={isLoadingTable}
                                                locale={{ emptyText: "Không có dữ liệu" }}
                                                dataSource={(danhsach || []).map((item: any, index: number) => {
                                                    return { ...item, key: index };
                                                })}
                                                columns={tableChiTietColumns}
                                            />
                                        )
                                    }
                                ]}
                            />
                        </div>
                    </Col>
                </Row>
            </section>
            {danhsach != undefined &&
                <section style={{ display: 'none' }}>
                    <div ref={componentRefCCT}>
                        <InChamCongThang ThongKeChamCong={danhsach} thangNam={searchData.thangNam}></InChamCongThang>
                    </div>
                    <div ref={componentRefCCTG}>
                        <InChamCongNgoaiGio ThongKeChamCong={danhsach} thangNam={searchData.thangNam}></InChamCongNgoaiGio>
                    </div>
                </section>
            }
            {openModalTrinh && <ModalTextForm
                title={`Văn phòng tổng hợp chấm công tháng ${dateCommon.formatDate(searchData.thangNam, "MM/yyyy")}`}
                show={openModalTrinh}
                handleClose={() => {
                    {
                        formTraLai.setFieldValue("idChamCong", undefined);
                        formTraLai.setFieldValue("lyDo", "");
                        setOpenModalTrinh(false);
                    }
                }
                }
                handleSave={() => { eventTrinhTongHopChamCong(); setOpenModalTrinh(false); }}
            >
                <> {user.maChucVu != maChucVu.phoCVP &&
                    <Col span={24} style={{ marginBottom: "10px" }}>
                        <Radio.Group
                            onChange={(value: any) => {
                                setTrinhPhoCVP(value.target.value);
                            }}
                            value={trinhPhoCVP}
                        > <Radio value={true}>Trình Phó Chánh Văn Phòng</Radio>
                            <Radio value={false}>Trình Chánh Văn Phòng</Radio>
                        </Radio.Group>
                    </Col>
                }
                    Bạn có muốn <label>Trình</label> bảng tổng hợp KPI này không?
                </>
            </ModalTextForm>
            }
            {openModalTraLai && <ModalTextForm
                title={`Văn phòng trả lại chấm công tháng ${dateCommon.formatDate(searchData.thangNam, "MM/yyyy")}`}
                hideFooter
                show={openModalTraLai}
                handleClose={() => {
                    {
                        formTraLai.setFieldValue("idChamCong", undefined);
                        formTraLai.setFieldValue("lyDo", "");
                        setOpenModalTraLai(false);
                    }
                }
                }
                handleSave={() => { setOpenModalTraLai(false); }}
            >
                <Form
                    layout="horizontal"
                    validateMessages={validateMessages}
                    onFinish={onFinish}
                    form={formTraLai}
                    labelCol={{ span: 5 }} 
                    wrapperCol={{ span: 19 }}
                >
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label="Bảng chấm công:"
                                labelAlign="left" 
                                name="idChamCong"
                                rules={[{ required: true }]}
                            >
                                <DonViChamCongSelectBox searchData={searchData} onChange={() => { }} />
                            </Form.Item>
                            <Form.Item
                                name="lyDo"
                                label="Lý do trả lại"
                                labelAlign="left"
                            >
                                <TextArea rows={4} placeholder="Lý do trả lại" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item className="float-right">
                        <Button type="primary" className="float-right" htmlType="submit" loading={loading}>
                            Đồng ý
                        </Button>
                    </Form.Item>
                </Form>
            </ModalTextForm>}
        </>
    );
};

export default ThongKeChamCong;
